import {useState, useEffect} from 'react';
import { useParams} from 'react-router-dom';
import axios from 'axios';
import { TableContainer } from "@mui/material";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import '../../Styles/Components/Persons/Preview_Person.css';
import Dialog_alert from '../PublicForms/Dialog_alert.js';
import {useNavigate } from "react-router-dom";
import Config from '../PublicForms/Config.js';
import isTokenExpired from '../PublicForms/isTokenExpired.js';
import Navigation_Bar from "../PublicForms/Navigation_Bar.js";
import Header from "../PublicForms/Header.js";
import iconAdd from '../../Images/iconAdd.png';
import { ScrollToTop } from '../PublicForms/ScrollToTop.js';




export default function Preview_Person(props) {

  const[openNav, setOpenNav] = useState(false);
  const{personID} = useParams();
  const [personIDState, setPersonIDState] = useState(personID);
  const [loading , setLoading] = useState(false);
  const [which, setWhich] = useState(personID.includes(undefined) ? "Add": "Edit");
  const [width, setWidth] = useState(0);
  const [cities, setCities] = useState([]);
  const [cityName, setCityName] = useState("");
  const [showCityTbl, setShowCityTbl] = useState(false);
  const [runUseEffect, setRunUseEffect] = useState(personID.includes(undefined) ? false : true);
  const [runCityUse, setRunCityUse] = useState(false);
  const[provinceID,setProvinceID] = useState();
  const[runProvinceUse, setRunProvinceUse] = useState(true);
  const[provinces, setProvinces] = useState(false);
  const[provinceName, setProvinceName] = useState("");
  const[showTblProvince, setShowTblProvince] = useState(false);
  const [filteredProvince, setFilteredProvince] = useState([]);
  const [runSetValueData, setRunSetValueData] = useState(false);
  const[runFilterProvince, setRunFilterProvince] = useState(false);
  const[citySearch, setCitySearch] = useState("");
  const [filteredCity, setFilteredCity] = useState([]);
  const[runFilterCity, setRunFilterCity] = useState(false);
  const[provinceSearch, setProvinceSearch] = useState("");
  const [runSaveData, setRunSaveData] = useState(false);
  const [runEditData, setRunEditData] = useState(false);
  const [runDelData, setRunDelData] = useState(false);
  const [data, setData] = useState([]);
  const [message, setMessage] = useState([]);
  const [messTitle, setMessTitle] = useState("");
  const [showDialog, setShowDialog] = useState(false);
  const[runOpen, setRunOpen] = useState(false);
  const Navigate = useNavigate();
  var validData = 0;
  

  useEffect(() => {
    if (localStorage.getItem('token')) {
      const token = localStorage.getItem('token');
      if (isTokenExpired(token)) {
        localStorage.removeItem('token');
        Navigate("/login");
    } else {
        // setUser(JSON.parse(localStorage.getItem('user')));
      }
    } else {
        Navigate("/login");
    }


  }, []);

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth)
    }
    
    window.addEventListener("resize", handleResize)
    
    handleResize()
    
    
  }, []);

//getProvinces
useEffect(()=>
  {
    const getProvinces = async ()=>
    {
          axios.get(`${Config.apiBaseUrl}/api/Province?chkActive=true`,{headers: {
     
            "Authorization":`Bearer ${localStorage.getItem('token')}`,
          }
        }).then(response => 
          {
                  if(response.status === 200)
                  {
                      setProvinces(response.data);
                     setFilteredProvince(response.data);
                      setRunProvinceUse(false);
                    //  setLoading(false);
                         
                  }else
                  {
                    setMessTitle("خطا");
                    setMessage((prevMessages) => {
                      return [
                          ...prevMessages, // shallow copy into new array reference
                          "مجددا تلاش کنید",      // append new element
                      ];
                  });
                   setShowDialog(true);
                  }
      
              }).catch((err) =>{
      
                console.log(err)
                if(err.response !== null && err.response !== undefined)
                  {
                        setMessage([]);
                        if(err.response.status == 401)
                        {
                            Navigate("/login");
            
            
                        }else if((err.response.status)==500)
                        {
                              setMessTitle("خطا");
                              setMessage((prevMessages) => {
                                  return [
                                      ...prevMessages, // shallow copy into new array reference
                                      (err.response.detail),      // append new element
                                  ];
                              });
                              setShowDialog(true);
                  
                        }else
                        {
                                setMessTitle("خطا");
                                setMessage((prevMessages) => {
                                    return [
                                      ...prevMessages, // shallow copy into new array reference
                                      "لطفا مجددا تلاش کنید",      // append new element
                                    ];
                                });
                                setShowDialog(true);
                
                        }
            
                  }else if(err.message == "Network Error")
                  {
                        setMessTitle("خطا");
                                setMessage((prevMessages) => {
                                    return [
                                      ...prevMessages, // shallow copy into new array reference
                                      "برقراری ارتباط با سرور امکان پذیر نمی باشد",      // append new element
                                    ];
                                });
                                setShowDialog(true);
                  }else
                  {
                        setMessTitle("خطا");
                        setMessage((prevMessages) => {
                            return [
                                ...prevMessages, // shallow copy into new array reference
                                ("لطفا مجددا تلاش کنید"),      // append new element
                            ];
                        });                
                        
                        setShowDialog(true);
                  }
              });
            
          
            
    };
     
    if(runProvinceUse)
    {
      getProvinces();
      
    }
  
  },[runProvinceUse]);
    
  
useEffect(()=>
{
  const getCities = async ()=>
    {
          axios.get(`${Config.apiBaseUrl}/api/Province/${provinceID}`,{headers: {
     
            "Authorization":`Bearer ${localStorage.getItem('token')}`,
          }
        }).then(response => 
          {
                  if(response.status === 200)
                  {

                      setCities(response.data.cities);
                      setFilteredCity(response.data.cities)
                      if(response.data.cities.length>0)
                      {
                         setShowCityTbl(true);
                      }
                      setRunCityUse(false);
                      //setShowTblProvince(false);
                    //  setLoading(false);
                         
                  }else
                  {
                    setMessTitle("خطا");
                    setMessage((prevMessages) => {
                      return [
                          ...prevMessages, // shallow copy into new array reference
                          "مجددا تلاش کنید",      // append new element
                      ];
                  });
                   setShowDialog(true);
                  }
      
              }).catch((err) =>{

                if(err.response !== null && err.response !== undefined)
                  {
                      setMessage([]);
                      if(err.response.status === 401)
                      {
                          Navigate("/login");
                      }else if((err.response.status) === 500)
                      {
                          setMessTitle("خطا");
                          setMessage((prevMessages) => {
                              return [
                                  ...prevMessages, // shallow copy into new array reference
                                  (err.response.detail),      // append new element
                              ];
                          });
                          setShowDialog(true);
          
                      }else
                      {
                          setMessTitle("خطا");
                          setMessage((prevMessages) => {
                              return [
                                  ...prevMessages, // shallow copy into new array reference
                                  "لطفا مجددا تلاش کنید",      // append new element
                              ];
                          });
                          setShowDialog(true);
              
                      }
          
                  }else if(err.message == "Network Error")
                  {
                      setMessTitle("خطا");
                      setMessage((prevMessages) => {
                          return [
                              ...prevMessages, // shallow copy into new array reference
                              "برقراری ارتباط با سرور امکان پذیر نمی باشد",      // append new element
                          ];
                      });
                      setShowDialog(true);
                  }else
                  {
                  setMessTitle("خطا");
                  setMessage((prevMessages) => {
                      return [
                          ...prevMessages, // shallow copy into new array reference
                          ("لطفا مجددا تلاش کنید"),      // append new element
                      ];
                  });                
                  
                  setShowDialog(true);
                  }
      
              });
            
          
            
    };
     
   
  if(runCityUse)
  {
    getCities();
    
  }

},[runCityUse])

//filter
useEffect(()=>
{
  if(runFilterProvince)
  {
    console.log(provinceSearch)
    provinceSearch === '' ?
     setFilteredProvince(provinces)
     :

     provinces.map((province)=>
      {
        if(province.provinceName.includes(provinceSearch))
        {
          setFilteredProvince((prev) => {
            return [
                ...prev, // shallow copy into new array reference
                (province),      // append new element
            ];
        });
        }
      }
    )
       
     
     setRunFilterProvince(false);
   
  }
  

},[runFilterProvince])

useEffect(()=>
  {
    if(runFilterCity)
    {
      
      citySearch === '' ?
       setFilteredCity(cities)
       :
  
       cities.map((city)=>
        {
          if(city.cityName.includes(citySearch))
          {
            setFilteredCity((prev) => {
              return [
                  ...prev, // shallow copy into new array reference
                  (city),      // append new element
              ];
          });
          }
        }
      )
       
       
       setRunFilterCity(false);
     
    }
    
  
  },[runFilterCity])

useEffect(()=>
{
  //setCityNameSrch("")
  setRunSetValueData(false)

}, [runSetValueData])

  const setPron = (val)=>
  {
    setProvinceName(val);
    setRunSetValueData(true)
  }

  const setCityn = (val)=>
  {
    setCityName(val);
    setRunSetValueData(true)
  }
  const setValueData = (val, indx) =>
  {
    if(indx === 3)
    {
      if(val !== undefined && val !== null && val !== "")
        {
          while(val.charAt(0) === "0")
            {
              val = val.substring(1);
            }
           
        }
      
    }

    var arr = data;

    arr[indx] = val;

    setData(arr);
    

  }


  const checkValidData = ()=>
  {
     validData = 0;
     const newArray = [
      ...message.slice(0), // Elements before the one to delete
      ...message.slice(message.length) // Elements after the one to delete
    ];        //0-fname, 1-lname, 2-bdate, 3-mobile, 4-home, 5-email, 6-city, 7-postal, 8-address, 9-descript

    setMessage(newArray)
    if(data[3] !== undefined && data[3] !== null && data[3] !== "")
    {
      var strTmp = data[3];
      
      while(strTmp.charAt(0) === "0")
        {
          strTmp = strTmp.substring(1);
        }
        var arrTmp = data;
        arrTmp[3] = strTmp;
        setData(arrTmp);
    }

    if(data[1] === undefined || data[1] === null ||  data[1] === "")
    {
      setMessTitle("توجه");
      var mess = " لطفا نام خانوادگی را تکمیل کنید";
      var tempArr = message;
      tempArr.push(mess);
      setMessage(tempArr);
      // setMessage((prevMesages) => {
      //   return prevMesages.concat(mess);
      // });
    }else
    {
      validData = validData +1;
    }

    if(((data[3] === undefined || data[3] === null || data[3] === "") && (data[4] === undefined || data[4] === null || data[4] === "")))
    {
      setMessTitle("توجه");
      var mess = " لطفا شماره همراه یا منزل را تکمیل کنید";
      var tempArr = message;
      tempArr.push(mess);
      setMessage(tempArr);
      
    }else
    {
      validData = validData +1;

    }

    if(data[6] === undefined || data[6] === null || data[6] === "")
    {
      setMessTitle("توجه");
      var mess = " لطفا نام شهر را تکمیل کنید";
      var tempArr = message;
      tempArr.push(mess);
      setMessage(tempArr);
      
    }else
    {
      validData = validData +1;

    }

    if(data[7] === undefined || data[7] === null || data[7] === "")
    {
      setMessTitle("توجه");
      var mess = " لطفا کد پستی را تکمیل کنید";
      var tempArr = message;
      tempArr.push(mess);
      setMessage(tempArr);
    }else
    {
      validData = validData +1;

    }

    if(data[8] === undefined || data[8] === null || data[8] === "")
    {
      setMessTitle("توجه");
      var mess = " لطفا آدرس را تکمیل کنید";
      var tempArr = message;
      tempArr.push(mess);
      setMessage(tempArr);
    }else
    {
      validData = validData +1;

    }
   

    //check phone length
        
    if((data[3] !== undefined && data[3] !== null && data[3] !== "") && data[3]?.length !== 10)
    {
      setMessTitle("توجه");
      var mess = "تعدادارقام شماره همراه باید 10 رقم باشد";
      var tempArr = message;
        tempArr.push(mess);
        setMessage(tempArr);
    }else if( (data[4] !== undefined && data[4] !== null && data[4] !== "") && data[4]?.length !== 11)
    {
      setMessTitle("توجه");
      var mess = "تعدادارقام شماره تماس منزل باید 11 رقم باشد";
      var tempArr = message;
      tempArr.push(mess);
      setMessage(tempArr);

    }else if(((data[3] !== undefined && data[3] !== null && data[3] !== "") && data[3]?.length === 10)||((data[4] !== undefined && data[4] !== null && data[4] !== "") && data[4]?.length === 8))
    {
        validData = validData +1;

    }
    
     
    
      if(data[7]?.length !== 10)
      {
        setMessTitle("توجه");
        var mess = "تعداد ارقام کد پستی باید 10 رقم باشد";
        var tempArr = message;
        tempArr.push(mess);
        setMessage(tempArr);
  
      }else
      {
        validData = validData +1;

      }


      if(validData === 7)
      {
        if(which === "Add")
        {

          setRunSaveData(true);

        }else
        {
          setRunEditData(true);
        }
        
      }else
      {
        setShowDialog(true);
      }
   

  }

  useEffect(()=>
 {
    const fetchPersonList = async () => {
        setLoading(true);
        axios.get(`${Config.apiBaseUrl}/api/Person/${personIDState}`,{headers: {
         
          "Authorization":`Bearer ${localStorage.getItem('token')}`,
        }
      }).then(response => 
        {
         
            if(response.status === 200)
            {
                setData(oldArr=>[...oldArr,response.data.firstName == null ? "---": response.data.firstName]);
                setData(oldArr=>[...oldArr,response.data.lastName == null ? "---" : response.data.lastName]);
                setData(oldArr=>[...oldArr,response.data.birthDate == null ? "---": response.data.birthDate]);
                
              //  if(response.data.birthDate !== null && response.data.birthDate !== "" && response.data.birthDate !== undefined)
              //  {
              //    var dateString = response.data.birthDate;
              //    year = parseInt(dateString.substring(0,4));
              //    month = parseInt(dateString.substring(dateString.indexOf("/")+1, dateString.lastIndexOf("/")));
              //    day = parseInt(response.data.birthDate.substring(dateString.lastIndexOf("/")+1));
              //    setDate(
              //     {year : year,
              //     month : month,
              //     day : day});

              //  }
              setData(oldArr=>[...oldArr,(response.data.phoneNumber == null ? "---" : response.data.phoneNumber)+""]);
              setData(oldArr=>[...oldArr,response.data.homeNumber== null ? "00000000": response.data.homeNumber]);
              setData(oldArr=>[...oldArr,response.data.personEmail == null ? "---":response.data.personEmail]);
              setData(oldArr=>[...oldArr,response.data.cityID]);
              setCityName(response.data.city.cityName);
              setProvinceName(response.data.city.province.provinceName);
              setProvinceID(response.data.city.provinceID);
              setData(oldArr=>[...oldArr,(response.data.postalCode)+""]);
              setData(oldArr=>[...oldArr,response.data.address]);
              setData(oldArr=>[...oldArr,response.data.degree == null ? "---": response.data.degree]);
              setData(oldArr=>[...oldArr,response.data.job == null ? "---": response.data.job]);
              setData(oldArr=>[...oldArr,response.data.personDescript == null ? "---":response.data.personDescript]);
              setRunCityUse(true);
              
            
                    
            }else
            {
              setMessTitle("خطا");
              setMessage((prevMessages) => {
                  return [
                      ...prevMessages, // shallow copy into new array reference
                      "لطفا مجددا تلاش کنید",      // append new element
                  ];
              });                
              
              setShowDialog(true);
            }

        }).catch((err) =>{

          if(err.response !== null && err.response !== undefined)
            {
                setMessage([]);
                if(err.response.status === 401)
                {
                    Navigate("/login");
                }else if((err.response.status) === 500)
                {
                    setMessTitle("خطا");
                    setMessage((prevMessages) => {
                        return [
                            ...prevMessages, // shallow copy into new array reference
                            (err.response.detail),      // append new element
                        ];
                    });
                    setShowDialog(true);
    
                }else
                {
                    setMessTitle("خطا");
                    setMessage((prevMessages) => {
                        return [
                            ...prevMessages, // shallow copy into new array reference
                            "لطفا مجددا تلاش کنید",      // append new element
                        ];
                    });
                    setShowDialog(true);
        
                }
    
          }else if(err.message == "Network Error")
          {
              setMessTitle("خطا");
              setMessage((prevMessages) => {
                  return [
                      ...prevMessages, // shallow copy into new array reference
                      "برقراری ارتباط با سرور امکان پذیر نمی باشد",      // append new element
                  ];
              });
              setShowDialog(true);
          }else
          {
          setMessTitle("خطا");
          setMessage((prevMessages) => {
              return [
                  ...prevMessages, // shallow copy into new array reference
                  ("لطفا مجددا تلاش کنید"),      // append new element
              ];
          });                
          
          setShowDialog(true);
          }
            
        })
        setRunUseEffect(false);
        setLoading(false);
    }

    if(runUseEffect)
    {

        fetchPersonList();

    }

    },[runUseEffect])

  useEffect(()=>
  {
   setMessage([]);
    const saveData = async ()=>
    {
      //0-fname, 1-lname, 2-bdate, 3-mobile, 4-home, 5-email, 6-city, 7-postal, 8-address, 9-descript
      axios.post(
        `${Config.apiBaseUrl}/api/Person`,{


          "firstName": data[0] !== undefined && data[0] !== null && data[0] !== "" ? data[0] : "---",
          "lastName": data[1]+"",
          "birthDate": data[2],
          "phoneNumber": data[3],
          "homeNumber": data[4],
          "personEmail": data[5] !== undefined && data[5] !== null && data[5] !== ""? data[5] : "---",
          "postalCode": data[7],
          "address": data[8],
          "degree": data[9],
          "job": data[10],
          // "subscriptState": false,
          "personDescript": data[11] !== undefined && data[11] !== null && data[11] !== "" ? data[11] : "---",
          "cityID": parseInt(data[6])
  
        },{headers: {
         
          "Authorization":`Bearer ${localStorage.getItem('token')}`,
        }
      }).then(response => 
      {
          if(response.status == 201)
          {
              
              setPersonIDState(response.data.personID);
              setWhich("Edit");
              setMessTitle("توجه");
              setMessage((prevMessages) => {
                  return [
                    ...prevMessages, // shallow copy into new array reference
                    "اطلاعات فرد مورد نظر شما با موفقیت ثبت شد",      // append new element
                  ];
                });
              setShowDialog(true);
  
          }else
          {
              setMessTitle("خطا");
              setMessage((prevMessages) => {
                  return [
                    ...prevMessages, // shallow copy into new array reference
                    "لطفا مجددا تلاش کنید",      // append new element
                  ];
              });
              setShowDialog(true);
          }
  
      }).catch((err) =>{
        if(err.response !== null && err.response !== undefined)
          {
              setMessage([]);
              if(err.response.status == 401)
              {
                  Navigate("/login");
  
  
              }else if((err.response.status)==500)
              {
                    setMessTitle("خطا");
                    setMessage((prevMessages) => {
                        return [
                            ...prevMessages, // shallow copy into new array reference
                            (err.response.data.detail),      // append new element
                        ];
                    });
                    setShowDialog(true);
        
              }else
              {
                      setMessTitle("خطا");
                      setMessage((prevMessages) => {
                          return [
                            ...prevMessages, // shallow copy into new array reference
                            "لطفا مجددا تلاش کنید",      // append new element
                          ];
                      });
                      setShowDialog(true);
      
              }
  
         }else if(err.message == "Network Error")
          {
              setMessTitle("خطا");
                      setMessage((prevMessages) => {
                          return [
                            ...prevMessages, // shallow copy into new array reference
                            "برقراری ارتباط با سرور امکان پذیر نمی باشد",      // append new element
                          ];
                      });
                      setShowDialog(true);
         }else
          {
              setMessTitle("خطا");
              setMessage((prevMessages) => {
                  return [
                      ...prevMessages, // shallow copy into new array reference
                      ("لطفا مجددا تلاش کنید"),      // append new element
                  ];
              });                
              
              setShowDialog(true);
         }
          
          
     })
     setRunSaveData(false);
     setWhich("Edit")
    
    }
   
    const editData = async ()=>
    {

      //0-fname, 1-lname, 2-bdate, 3-mobile, 4-home, 5-email, 6-city, 7-postal, 8-address, 9-descript
      axios.put(
        `${Config.apiBaseUrl}/api/Person/${personID}?FirstName=${data[0]}&LastName=${data[1]}&BirthDate=${data[2]}&PhoneNumber=${data[3]}&HomeNumber=${data[4]}&PersonEmail=${data[5]}&PostalCode=${data[7]}&Address=${data[8]}&Degree=${data[9]}&Job=${data[10]}&PersonDescript=${data[11]}&CityID=${data[6]}`
         
        ,{},{headers: {
         
          "Authorization":`Bearer ${localStorage.getItem('token')}`,
        }
      }).then(response => 
      {
          if(response.status == 204)
          {
              setMessTitle("توجه");
              setMessage((prevMessages) => {
                  return [
                    ...prevMessages, // shallow copy into new array reference
                    "اطلاعات فرد مورد نظر شما با موفقیت به روز شد",      // append new element
                  ];
                });
              setShowDialog(true);
  
          }else
          {
              setMessTitle("خطا");
              setMessage((prevMessages) => {
                  return [
                    ...prevMessages, // shallow copy into new array reference
                    "لطفا مجددا تلاش کنید",      // append new element
                  ];
              });
              setShowDialog(true);
          }
  
      }).catch((err) =>{

        if(err.response !== null && err.response !== undefined)
          {
                setMessage([]);
                if(err.response.status == 401)
                {
                    Navigate("/login");
    
    
                }else if((err.response.status)==500)
                {
                      setMessTitle("خطا");
                      setMessage((prevMessages) => {
                          return [
                              ...prevMessages, // shallow copy into new array reference
                              (err.response.detail),      // append new element
                          ];
                      });
                      setShowDialog(true);
          
                }else
                {
                        setMessTitle("خطا");
                        setMessage((prevMessages) => {
                            return [
                              ...prevMessages, // shallow copy into new array reference
                              "لطفا مجددا تلاش کنید",      // append new element
                            ];
                        });
                        setShowDialog(true);
        
                }
    
        }else if(err.message == "Network Error")
        {
              setMessTitle("خطا");
                      setMessage((prevMessages) => {
                          return [
                            ...prevMessages, // shallow copy into new array reference
                            "برقراری ارتباط با سرور امکان پذیر نمی باشد",      // append new element
                          ];
                      });
                      setShowDialog(true);
        }else
        {
              setMessTitle("خطا");
              setMessage((prevMessages) => {
                  return [
                      ...prevMessages, // shallow copy into new array reference
                      ("لطفا مجددا تلاش کنید"),      // append new element
                  ];
              });                
              
              setShowDialog(true);
        }
          
          
      })
      setRunEditData(false);
    }

    const deleteData = async ()=>
      {
        //0-fname, 1-lname, 2-bdate, 3-mobile, 4-home, 5-email, 6-city, 7-postal, 8-address, 9-descript
        axios.delete(
          `${Config.apiBaseUrl}/api/Person/${personID}`,{headers: {
         
            "Authorization":`Bearer ${localStorage.getItem('token')}`,
          }
        }).then(response => 
        {
            if(response.status == 204)
            {
                setMessTitle("توجه");
                setMessage((prevMessages) => {
                    return [
                      ...prevMessages, // shallow copy into new array reference
                      "اطلاعات فرد مورد نظر شما با موفقیت حذف شد",      // append new element
                    ];
                  });
                setShowDialog(true);
    
            }else
            {
                setMessTitle("خطا");
                setMessage((prevMessages) => {
                    return [
                      ...prevMessages, // shallow copy into new array reference
                      "لطفا مجددا تلاش کنید",      // append new element
                    ];
                });
                setShowDialog(true);
            }
    
        }).catch((err) =>{
            
            if(err.response !== null && err.response !== undefined)
            {
              setMessage([]);
              if(err.response.status == 401)
              {
                  Navigate("/login");
  
  
              }else if((err.response.status) === 400)
              {
                      setMessTitle("خطا");
                      setMessage((prevMessages) => {
                          return [
                            ...prevMessages, // shallow copy into new array reference
                            ("اطلاعات این کاربر قبلا حذف شده است."),      // append new element
                          ];
                      });
                      setShowDialog(true);
      
              }else
              {
                      setMessTitle("خطا");
                      setMessage((prevMessages) => {
                          return [
                            ...prevMessages, // shallow copy into new array reference
                            "لطفا مجددا تلاش کنید",      // append new element
                          ];
                      });
                      setShowDialog(true);
      
              }
      
            }else if(err.message == "Network Error")
            {
                setMessTitle("خطا");
                setMessage((prevMessages) => {
                    return [
                      ...prevMessages, // shallow copy into new array reference
                      "برقراری ارتباط با سرور امکان پذیر نمی باشد",      // append new element
                    ];
                });
                setShowDialog(true);
            }else
            {
                  setMessTitle("خطا");
                  setMessage((prevMessages) => {
                      return [
                          ...prevMessages, // shallow copy into new array reference
                          ("لطفا مجددا تلاش کنید"),      // append new element
                      ];
                  });                
                  
                  setShowDialog(true);
            }
        })
    }


    if(runSaveData === true)
    {  
      saveData();

    }else if(runEditData === true)
    {
      editData();
      
    }else if(runDelData)
    {
       deleteData();

    }


  },[runSaveData, runEditData, runDelData]);

 
  //message dialog
  const closeOpenDialog = (open) =>
  {
 
    var arr = message;
    arr.splice(0, message.length);
    setMessage(arr);
    setShowDialog(false);
    if(runDelData)
      {
        setRunDelData(false);

      }
          
  }


  function goToShowDescript()
  {
    
    Navigate(`/subscripts/lstSubscripts/اشتراک/subScriptLst/${personIDState}/true/false`);

    
  }

  const handleNave = ()=>
  {
    
      setOpenNav(!openNav);
      

  }

  const handleNaveForm = ()=>
  {
    if(!openNav)
      {
        setOpenNav(!openNav)
      }
  }


  if(width>999)
  {
    return (
      <div className='prevPerson' >
                <ScrollToTop />

             <Header />

                    
                <div className="navClass">
                    <Navigation_Bar />
                
                </div>
                
               <div className='prevPersonContainer' onClick={()=>{setRunOpen(true)
               }}>
                  <div className='row'>
                    <div className='col-sm-1'></div>
                    <div className='col-sm-11 prevPersonForm'>
                        <div className='row'>

                            <div className="col-sm-4 form-group" >
                                <label htmlFor="name">نام</label>
                                <input type="text"   className="form-control" id="name" defaultValue={data[0]}  onChange={(e)=>setValueData(e.target.value,0)} />
                            </div>

                            <div className="col-sm-4 form-group">
                                <label htmlFor="family">نام خانوادگی  &#9733;</label>
                                <input type="text"  className="form-control" id="family" defaultValue={data[1]} onChange={(e)=>setValueData(e.target.value,1)}/>

                            </div>

                            <div className="col-sm-4 form-group ">
                                <div>
                                <label htmlFor="birthdate">تاریخ تولد</label>

                                </div>
                                <div className="myContainer">

                                <DatePicker
                                  
                                    value={data[2]}
                                    calendar={persian}
                                    locale={persian_fa}
                                    calendarPosition="bottom-right"
                                    onChange = { e => setValueData(e !== null ? e.year+"/"+e.month+"/"+e.day : "",2)}
                                    
                                  />
                                </div>                                           

                            </div>

                      
                          <div className="col-sm-4 form-group">
                              <label htmlFor="phone">شماره تلفن همراه  &#9733;</label>
                              <input type="number"  className="form-control" id="phone" defaultValue={data[3]} onChange={(e)=>{
                                setValueData((e.target.value),3)}}
                                onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}/>

                          </div>

                          <div className="col-sm-4 form-group">
                              <label htmlFor="phoneHome">شماره تلفن منزل</label>
                              <input type="number" className="form-control" id="phoneHome" defaultValue={data[4]} onChange={(e)=>setValueData(e.target.value,4)}
                                  onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}/>

                          </div>

                          <div className="col-sm-4 form-group">
                              <label htmlFor="email">ایمیل</label>
                              <input type="email"   className="form-control" id="email" defaultValue={data[5]} onChange={(e)=>setValueData(e.target.value,5)}/>

                          </div>

                      
                        <div className='col-md-4 form-group'>

                          <label>استان  &#9733;</label>
                          <div>
                            <input type="text" className="form-control" onChange={(e)=>{setProvinceSearch(e.target.value);
                              setRunFilterProvince(true);
                              setFilteredProvince([])
                            }} id="province"  onClick={()=>{
                              // setProvinceName("");
                              // setProvinceSearch("");
                              setShowTblProvince(!showTblProvince);
                              setShowCityTbl(false);
                              
                              }}  defaultValue={provinceSearch} placeholder='جست جوی نام استان...'/>
                            <div className='cityValues'>

                              {
                                  showTblProvince ? <TableContainer style={{ maxHeight: 80 }} className='tableContainer'>

                                <table
                                  className="table table-condensed"
                                  style={{ textAlign: "right", padding:'5%' }}
                                  
                                >
                                  
                                  <tbody >            
                                  
                                    {filteredProvince?.map((province,index) => {
                                      return (
                                        <tr key={index} onClick={()=>{
                                          //setProvinceName(province.provinceName);
                                          setPron(province.provinceName)
                                          setCityName("");
                                          setCitySearch("");
                                          setProvinceSearch(province.provinceName)
                                          setProvinceID(province.provinceID);
                                          setRunCityUse(true);
                                        //  setRunSetValueData(true)

                                        }}>
                                          <td>{provinceID == province.provinceID ? <>&#x2713;</>:<></>}</td>
                                          <td >
                                            {province.provinceName}
                                          </td>
                                          
                                        </tr>
                                      
                                      );
                                      })
                                    }
                                  
                                  </tbody>
                                </table> 

                              </TableContainer>
                              : null
                              }
                              

                            </div>
                          </div>
                        </div>

                         
                         <div className='col-sm-4 form-group'>
                          <div style={{width:'100%'}}>

                          <label>شهر  &#9733;</label>
                                    <div className='citySearchForm'>
                                     
                                          <input type="text" className="form-control" id="city"  onChange={(e)=>{setCitySearch(e.target.value)
                                            setRunFilterCity(true)
                                            setFilteredCity([])

                                           
                                          }}  
                                          onClick={()=>
                                          {
                                            setRunCityUse(provinceID !== undefined ? true : false);
                                            setShowCityTbl(!showCityTbl);

                                            
                                          }}  defaultValue={citySearch} placeholder='جست جوی نام شهر...' />

                                          
                                      <div className='cityValues'>

                                        {
                                            showCityTbl ? <TableContainer style={{ maxHeight: 80 }} className='tableContainer'>

                                          <table
                                            className="table table-condensed"
                                            style={{ textAlign: "right", padding:'5%' }}
                                            
                                          >
                                            
                                            <tbody >            
                                            
                                              {filteredCity?.map((ct,index) => {
                                                return (
                                                  <tr key={index} onClick={()=>{
                                                      setCityn(ct.cityName);
                                                      setCityName("");
                                                      setValueData(ct.cityID,6);
                                                      setCityName(ct.cityName);

                                                    
                                                  }}>
                                                    <td>{data[6] == ct.cityID ? <>&#x2713;</>:<></>}</td>

                                                    <td >
                                                      {ct.cityName}
                                                    </td>
                                                    
                                                  </tr>
                                                
                                                );
                                                })
                                              }
                                            
                                            </tbody>
                                          </table> 

                                        </TableContainer>
                                        : null
                                        }
                                        

                                      </div>
                                    </div>


                            <div className='imgAddCity' onClick={()=>Navigate(`/settings/previewCity/تنظیمات/newCity/0`)}>
                                    <img src={iconAdd} />
                             </div>
  
                          </div>

                          </div>
                          <div className="col-sm-4 form-group">
                              <label htmlFor="postalCode">کد پستی  &#9733;</label>
                              <input type="number" className="form-control" id="postalCode"  defaultValue={data[7]} onChange={(e)=>setValueData(e.target.value,7)}
                                  onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}/>

                          </div>

                          <div className="col-sm-4 form-group">

                            <label htmlFor="address">آدرس  &#9733;</label>
                            <textarea type="text" rows="1" className="form-control" id="address" defaultValue={data[8]} onChange={(e)=>setValueData(e.target.value,8)}/>

                          </div>

                    
                               
                            <div className="col-sm-4 form-group">
                                <label htmlFor="degree">مدرک تحصیلی</label>
                                <input type="text" className="form-control"  id="degree" defaultValue={data[9]} onChange={(e)=>setValueData(e.target.value,9)}/>

                            </div> 
                            
                            <div className="col-sm-4 form-group">
                                <label htmlFor="job">شغل</label>
                                <input type="text" className="form-control" id="job" onClick={()=>setShowCityTbl(false)} defaultValue={data[10]} onChange={(e)=>setValueData(e.target.value,10)}/>

                            </div>

                            <div className="col-sm-4 form-group">
                                <label htmlFor="descript">توضیحات</label>
                                <textarea type="text" rows="5" className="form-control"  id="descript" defaultValue = {data[11]} onChange={(e)=>setValueData(e.target.value,11)}></textarea>

                            </div>                                 

                        
                        
                        
                    </div>

                    {showDialog ? <Dialog_alert show = {showDialog} closeOpenDialog = {closeOpenDialog} messTitle ={messTitle} message = {message}/> : null}
                   
                  </div>
                  </div>

                       <div className='buttonContainer'>
                            <button  type='button' onClick={()=>{
                              setMessage([]);
                              checkValidData();
                            }} autoFocus>
                              {which === "Add" ? "ثبت" : "ویرایش"}
                            </button>
                            {
                              which === "Edit" ?
                                 <>
                                   

                                    <button  type='button' onClick={()=>setRunDelData(true)} >
                                      حذف
                                    </button>
                                    <button  type='button' onClick={()=> goToShowDescript()} >
                                      سوابق اشتراک
                                    </button>
                                 </>
                              : null
                            } 
                            
                            

                        </div>
               </div>           
              
           </div>
  
    );
  }else
  {
    return (
      <div className='prevPerson-all-responsive'>


           <div className= {openNav? "navClass" : "navClass navClassOpen"}>  
                              

              <Navigation_Bar />
                                
           </div>
                


          <div className='prevPerson' >

             <Header handleNave={handleNave} /> 
             <ScrollToTop />
          

               <div className='prevPersonContainer'  onClick={()=>handleNaveForm()}>

                  <div className='row'>
                    <div className='prevPersonForm'  >

                        <div className='row'>


                            <div className="col-sm-6 col-md-4 form-group" >
                                <label htmlFor="name">نام</label>
                                <input type="text" autoFocus  onClick={()=>setShowCityTbl(false)} className="form-control" id="name" defaultValue={data[0]}  onChange={(e)=>setValueData(e.target.value,0)} />
                            </div>

                            <div className="col-sm-6 col-md-4 form-group">
                                <label htmlFor="family">نام خانوادگی  &#9733;</label>
                                <input type="text" onClick={()=>setShowCityTbl(false)} className="form-control" id="family" defaultValue={data[1]} onChange={(e)=>setValueData(e.target.value,1)}/>

                            </div>

                            <div className="col-sm-6 col-md-4 form-group">
                                  <div>
                                    <label htmlFor="birthdate">تاریخ تولد</label>

                                  </div>
                                  <div className="myContainer">

                                  <DatePicker
                                    onClick={()=>setShowCityTbl(false)}
                                      value={data[2]}
                                      calendar={persian}
                                      locale={persian_fa}
                                      calendarPosition="bottom-right"
                                      onChange = { e => setValueData(e !== null ? e.year+"/"+e.month+"/"+e.day : "",2)}
                                      
                                    />
                                  </div>                                           

                            </div>                        

                          <div className="col-sm-6 col-md-4 form-group">
                              <label htmlFor="phone">شماره تلفن همراه  &#9733;</label>
                              <input type="number" onClick={()=>setShowCityTbl(false)} className="form-control" id="phone" defaultValue={data[3]} onChange={(e)=>{
                                setValueData((e.target.value),3)}}
                                onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}/>

                          </div>

                          <div className="col-sm-6 col-md-4 form-group">
                              <label htmlFor="phoneHome">شماره تلفن منزل</label>
                              <input type="number" onClick={()=>setShowCityTbl(false)} className="form-control" id="phoneHome" defaultValue={data[4]} onChange={(e)=>setValueData(e.target.value,4)}
                                  onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}/>

                          </div>

                          <div className="col-sm-6 col-md-4 form-group">
                              <label htmlFor="email">ایمیل</label>
                              <input type="email"  onClick={()=>setShowCityTbl(false)} className="form-control" id="email" defaultValue={data[5]} onChange={(e)=>setValueData(e.target.value,5)}/>

                          </div>

                        
                          <div className='col-md-4 form-group'>

                              <label>استان  &#9733;</label>
                        <div>
                          <input type="text" className="form-control" onChange={(e)=>{setProvinceSearch(e.target.value);
                            setRunFilterProvince(true);
                            setFilteredProvince([])
                          }} id="province"  onClick={()=>{
                            // setProvinceName("");
                            // setProvinceSearch("");
                            setShowTblProvince(!showTblProvince);
                            setShowCityTbl(false);
                            
                            }}  defaultValue={provinceSearch} placeholder='جست جوی نام استان...'/>
                          <div className='cityValues'>

                            {
                                showTblProvince ? <TableContainer style={{ maxHeight: 80 }} className='tableContainer'>

                              <table
                                className="table table-condensed"
                                style={{ textAlign: "right", padding:'5%' }}
                                
                              >
                                
                                <tbody >            
                                
                                  {filteredProvince?.map((province,index) => {
                                    return (
                                      <tr key={index} onClick={()=>{
                                        //setProvinceName(province.provinceName);
                                        setPron(province.provinceName)
                                        setCityName("");
                                        setCitySearch("");
                                        setProvinceSearch(province.provinceName)
                                        setProvinceID(province.provinceID);
                                        setRunCityUse(true);
                                      //  setRunSetValueData(true)

                                      }}>
                                        <td>{provinceID == province.provinceID ? <>&#x2713;</>:<></>}</td>
                                        <td >
                                          {province.provinceName}
                                        </td>
                                        
                                      </tr>
                                    
                                    );
                                    })
                                  }
                                
                                </tbody>
                              </table> 

                            </TableContainer>
                            : null
                            }
                            

                          </div>
                        </div>
                        </div>


                        <div className='col-sm-4 form-group'>
                        <div style={{width:'100%'}}>

                        <label>شهر  &#9733;</label>
                                  <div className='citySearchForm'>
                                  
                                        <input type="text" className="form-control" id="city"  onChange={(e)=>{setCitySearch(e.target.value)
                                          setRunFilterCity(true)
                                          setFilteredCity([])

                                        
                                        }}  
                                        onClick={()=>
                                        {
                                          setRunCityUse(provinceID !== undefined ? true : false);
                                          setShowCityTbl(!showCityTbl);

                                          
                                        }}  defaultValue={citySearch} placeholder='جست جوی نام شهر...' />

                                        
                                    <div className='cityValues'>

                                      {
                                          showCityTbl ? <TableContainer style={{ maxHeight: 80 }} className='tableContainer'>

                                        <table
                                          className="table table-condensed"
                                          style={{ textAlign: "right", padding:'5%' }}
                                          
                                        >
                                          
                                          <tbody >            
                                          
                                            {filteredCity?.map((ct,index) => {
                                              return (
                                                <tr key={index} onClick={()=>{
                                                    setCityn(ct.cityName);
                                                    setCityName("");
                                                    setValueData(ct.cityID,6);
                                                    setCityName(ct.cityName);

                                                  
                                                }}>
                                                  <td>{data[6] == ct.cityID ? <>&#x2713;</>:<></>}</td>

                                                  <td >
                                                    {ct.cityName}
                                                  </td>
                                                  
                                                </tr>
                                              
                                              );
                                              })
                                            }
                                          
                                          </tbody>
                                        </table> 

                                      </TableContainer>
                                      : null
                                      }
                                      

                                    </div>
                                  </div>


                          <div className='imgAddCity' onClick={()=>Navigate(`/settings/previewCity/تنظیمات/newCity/0`)}>
                                  <img src={iconAdd} />
                          </div>

                        </div>

                        </div>

                          <div className="col-sm-6 col-md-4 form-group">
                              <label htmlFor="postalCode">کد پستی  &#9733;</label>
                              <input type="number" className="form-control" id="postalCode" onClick={()=>setShowCityTbl(false)} defaultValue={data[7]} onChange={(e)=>setValueData(e.target.value,7)}
                                  onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}/>

                          </div>

                          <div className="col-sm-6 col-md-4 form-group">

                            <label htmlFor="address">آدرس  &#9733;</label>
                            <textarea type="text" rows="1" className="form-control" onClick={()=>setShowCityTbl(false)} id="address" defaultValue={data[8]} onChange={(e)=>setValueData(e.target.value,8)}/>

                          </div>

                         
                        

                               
                            <div className="col-sm-6 col-md-4 form-group">
                                <label htmlFor="degree">مدرک تحصیلی</label>
                                <input type="text" className="form-control" onClick={()=>setShowCityTbl(false)} id="degree" defaultValue={data[9]} onChange={(e)=>setValueData(e.target.value,9)}/>

                            </div> 
                            
                            <div className="col-sm-6 col-md-4 form-group">
                                <label htmlFor="job">شغل</label>
                                <input type="text" className="form-control" id="job" onClick={()=>setShowCityTbl(false)} defaultValue={data[10]} onChange={(e)=>setValueData(e.target.value,10)}/>

                            </div>

                            <div className="col-sm-6 col-md-4 form-group">
                                <label htmlFor="descript">توضیحات</label>
                                <textarea type="text" rows="5" className="form-control" onClick={()=>setShowCityTbl(false)} id="descript" defaultValue = {data[11]} onChange={(e)=>setValueData(e.target.value,11)}></textarea>

                            </div>                                 

                            </div>

                        
                        
                    </div>

                    {showDialog ? <Dialog_alert show = {showDialog} closeOpenDialog = {closeOpenDialog} messTitle ={messTitle} message = {message}/> : null}
                   
                  </div>

                       <div className='buttonContainer'>

                       
                            <button  type='button' onClick={()=>{
                              setMessage([]);
                              checkValidData();
                            }} autoFocus>
                              {which === "Add" ? "ثبت" : "ویرایش"}
                            </button>
                            {
                              which === "Edit" ?
                                 <>
                                   

                                    <button  type='button' onClick={()=>setRunDelData(true)} >
                                      حذف
                                    </button>
                                    <button  type='button' onClick={()=> goToShowDescript()} >
                                      سوابق اشتراک
                                    </button>
                                 </>
                              : null
                            } 
                            
                            


                        </div>
               </div>           
              
           </div>
      </div>
    );
  }
 
    

}

 

